import React from 'react';
import logo from "~/assets/img/logo.svg";

import { useTranslation } from "react-i18next";

const JoinPageHeader = ({currentStep}) => {

    const navDots = ['policy', 'joinForm', 'mailSend', 'confirm'];
    const { t } = useTranslation();

    return (
        <div className="register-card-head">
            <h1 className="logo">
                <img src={logo} alt={t("pages.auth.JoinPage.components.header.JoinPageHeader.logo")} />
            </h1>
            <ol className="register-progress">
                {navDots.map((nav, i) => {
                    const current = currentStep === nav ? "current" : null ;
                    return (
                        <li key={i} className={current}></li>
                    )
                })}
            </ol>
        </div>
    );
};

export default JoinPageHeader;